// Natural sort for volunteer lists by V-code (V1, V2, ..., V9, V10, V11).
// Falls back to alphabetic comparison on the raw code when no number is found.
export const naturalVCodeCmp = (a, b) => {
  const ca = (a?.study_volunteer_code || '').trim();
  const cb = (b?.study_volunteer_code || '').trim();
  const na = parseInt(ca.replace(/[^\d]/g, ''), 10);
  const nb = parseInt(cb.replace(/[^\d]/g, ''), 10);
  const aHas = Number.isFinite(na);
  const bHas = Number.isFinite(nb);
  if (aHas && bHas && na !== nb) return na - nb;
  if (aHas && !bHas) return -1;
  if (!aHas && bHas) return 1;
  return ca.localeCompare(cb);
};

export const sortByVCode = (list) => (Array.isArray(list) ? [...list].sort(naturalVCodeCmp) : []);
